import React, { Component } from 'react';
import { IoIosCheckmark } from "react-icons/io";
import PageContent from '../../../../reusable-components/ActivatePageContent';
import PageHeader from '../../../../reusable-components/ActivatePageHeader';
import PropTypes from 'prop-types';

export default class StepSixComponent extends Component {
  constructor(props){
    super(props);
  }

  render() {

    return (
      <>
        <PageHeader title="Activeer Vignet" />
        <PageContent 
          title=""
          goBack={() => {}}
          moveNext={() => {}}
          cardClass="card-container"
          showFooter={false}
          formClassNames=""
          >
        <div className="form-container">
          <div className="success-message text-center">
            <div className="icon">
              <IoIosCheckmark size={48}/>
            </div>
            <h3>Dank u wel !</h3>
            {/*<span>Uw vignet is geactiveerd, een <br/> bevestigings e­mail wordt naar uw e­mail adres gestuurd.</span>*/}
            <span>Uw vignet is na goedkeuring geactiveerd, <br/> u ontvangt hierover een email</span>
          </div>
        </div>
        </PageContent>
      </>
    );
  }
}

